import React, { Fragment,useEffect,useState } from "react";
import Cookies from "universal-cookie";
import logo from "../assets/images/logo.svg";
import mobImg from "../assets/images/signup-image-01.svg";

function Employers() {



    const [isload, setLoad] = useState(false);
  useEffect(() => {
    // if (!didMount.current) {
    const cookies = new Cookies();
    const _loginForm = cookies.get("loginForm");
    if (_loginForm !== undefined) {
      // Object.keys(_loginForm).forEach(cookieName => {
      //   inputValue[cookieName] = _loginForm[cookieName];
      // });

      
    }
    // setInputValue({ ...inputValue });
    setLoad(true);
    // }
    // return () => {
    //   didMount.current = true;
    // };
  }, []);

       

  return (
    <Fragment>
      {" "}
      {isload && (
        <>
          <div className="login-page-header">
            <a href="/" className="logo-container">
              <img src={logo} alt="InstaDouch Logo" className="logo" />
            </a>
            <nav>
            <a href="/homepage" className="nav-menu-item">
                Home
              </a>
              <a href="/company" className="nav-menu-item">
                Company
              </a>
              <a href="/employers" className="nav-menu-item login-link">
                Employers
              </a>
              <a href="/employees" className="nav-menu-item">
                Employees
              </a>
              <a href="/fAQs" className="nav-menu-item">
                FAQs
              </a>
              <a href="/" className="nav-menu-item">
                Login
                {/* <div className="login-dropdown-container">
                  <a href="#" className="login-dropdown-link-item">
                    Employee Login
                  </a>
                  <a href="#" className="login-dropdown-link-item">
                    Employer Login
                  </a>
                </div> */}
              </a>
            </nav>
          </div>
            {/* Login screen end  */}
            <div class="public-page-container">
      <div class="public-page-wrapp">
        <div class="public-page-image-left">
        <a href="/" className="logo-container">
              <img src={mobImg} alt="InstaDouch Logo" className="logo" />
            </a>
        </div>

        <div class="public-page-content-right top1">
          <h2 class="login-register-form-heading mt-40 mb-20">Employers</h2>

          <div class="form-row">
            <p class="color-white">
              Offering DoughPay, an instant pay, earned wage access product to
              your employees offers significant benefits to your organization
              including:
            </p>

            <br />

            <ul class="public-page-list-style">
              <li>No Cost to Implement</li>
              <li>Reduce Expenses</li>
              <li>Improve Productivity</li>
              <li>Employee Retention and Attraction</li>
              <li>Improving Net Working Capital Float</li>
              <li>
                Who would have known, doing the right thing, is the profitable
                thing!
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
        </>
      )}
    </Fragment>
  );
}

export default Employers;
